import Vue from 'vue';
import VueMask from 'v-mask';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

//import { request } from '../src/axiosService.js'


window.Vue = require('vue').default;
Vue.component('login', require('./components/login.vue').default);
Vue.component('dashboard', require('./components/dashboard.vue').default);
Vue.component('switch-student', require('./components/switchStudent.vue').default);
Vue.component('home-page', require('./components/homePage.vue').default);
Vue.component('time-table', require('./components/timeTable.vue').default);
Vue.component('profile', require('./components/profile.vue').default);
Vue.component('attendance', require('./components/school/attendance/attendance.vue').default);
Vue.component('lecture-attendance', require('./components/school/attendance/lectureAttendance.vue').default);
Vue.component('exams', require('./components/school/exams/exams.vue').default);
Vue.component('examresult', require('./components/school/exams/result.vue').default);
Vue.component('fee', require('./components/school/fee/fee.vue').default);
Vue.component('student-fee', require('./components/school/fee/StudentFeeChallan.vue').default);
Vue.component('feeprint', require('./components/school/fee/feeChallan.vue').default);
Vue.component('lesson-plan', require('./components/school/lessonPlan/lessonPlan.vue').default);
Vue.component('lesson-plan-print', require('./components/school/lessonPlan/lessonPlanPrint.vue').default);
Vue.component('courseresultprint', require('./components/school/print/courseResultPrint.vue').default);
Vue.component('attendanceprint', require('./components/school/print/attendancePrint.vue').default);
Vue.component('exam-form', require('./components/school/LMS/examForm.vue').default);
Vue.component('assingment', require('./components/school/LMS/assingment.vue').default);
Vue.component('daily-dairy', require('./components/school/LMS/dailyDairy.vue').default);
Vue.component('upload-assingment', require('./components/school/LMS/uploadAssingment.vue').default);
Vue.component('curriculum-resources', require('./components/school/LMS/curriculumResources.vue').default);
Vue.component('operational-resources', require('./components/school/LMS/OperationalResources.vue').default);

//Vue.component('print', require('./components/fee/feeChallanPrint.vue').default);
Vue.component('file-upload-list', require('./components/school/LMS/fileUploadList.vue').default);
Vue.component('feed-back-survey-form', require('./components/school/LMS/feedBackSurveyForm.vue').default);
Vue.component('general-feedback-form', require('./components/school/LMS/generalFeedbackForm.vue').default);
Vue.component('general-feedback-list', require('./components/school/LMS/generalFeedbackList.vue').default);
Vue.component('stepping-stone-result-card-print', require('./components/school/LMS/steppingStoneResultCardPrint.vue').default);
Vue.component('complaints', require('./components/school/complaint/Complaints.vue').default);


Vue.component('my-header', require('./components/school/core/header.vue').default);

 

Vue.component('v-select', vSelect);



Vue.use(VueMask);

const app = new Vue({
  el: '#app',
});



// WEBPACK FOOTER //
// ./src/main.js